<nav class="navbar bg-body-tertiary">
  <div class="d-flex justify-content-between align-items-center w-100 m-3">
    <!-- Left: search -->
    <input class="form-control w-auto" type="text" placeholder="Search" #searchBox
      (keyup.enter)="onBoxValue(searchBox.value)"
      (keyup)="onDebounce(searchBox.value)">

      <!-- Right: projected actions + optional Add button -->
      <div class="d-flex align-items-center gap-2">
        <ng-content></ng-content>

        <!-- render default button only if there's a non-empty label -->
        @if (buttonLabel) {
          <button
            hasAnyRole
            [viewRoles]="[Roles.ADMIN]"
            class="btn btn-outline-success w-auto"
            type="button"
            [routerLink]="linkUrl">
            Add {{buttonLabel}}
          </button>
        }
      </div>
    </div>
  </nav>
